import Game from "./Game";
import { SCENES } from "../constants/scenes";
import { MAPS } from "../constants/maps";

export default class FirstLevel extends Game {
  constructor() {
    super(SCENES.FIRST_LEVEL, MAPS.firstLevel.key);
  }
}
